// extracted by mini-css-extract-plugin
export var explainable = "_ip-a";
export var printerCard = "_ip-1";
export var printerCardConfigured = "_ip-2";
export var printerCardError = "_ip-3";
export var printerCardsContainer = "_ip-0";
export var printerIcon = "_ip-8";
export var printerIconConfigured = "_ip-5";
export var printerIconContainer = "_ip-4";
export var printerIconError = "_ip-6";
export var printerIconUnconfigured = "_ip-7";
export var workstationsTableCard = "_ip-9";